import _extends from "@babel/runtime/helpers/extends";
import { i18n } from "@lingui/core";
import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import React from 'react';
import { BaseField, renderFieldVerticalWrapper } from '../BaseField';
import { selectFieldRenderer } from '../fieldRenderers';
import { useAutoselectForDataFields, useSyncValues } from '../hooks/useAutoselectForDataFields';
import { useDynamicCartypesFetcher } from '../hooks/useDynamicCartypesFetcher';
import { useStateMachineForDataFields } from '../hooks/useStateMachineForFields';
export function SplitBuiltDates(_ref) {
  let {
    label = i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.builtDate'
    }),
    placeholder = i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.builtDate'
    }),
    className,
    onChange,
    ...props
  } = _ref;
  const name = formNames.builtDate;
  const {
    carTypesSplitModule: {
      getBuiltDates
    }
  } = useModulesStore();
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames,
    fieldFetchParams
  } = useStateMachineForDataFields({
    name
  });
  const {
    data
  } = useDynamicCartypesFetcher({
    name,
    enabled: isFieldEnabled,
    queryFn: getBuiltDates,
    params: fieldFetchParams,
    responseTransformConfig: {
      order: 'desc'
    }
  });
  useAutoselectForDataFields(name, data);
  useSyncValues(name);
  return /*#__PURE__*/React.createElement(BaseField, _extends({
    label: label,
    name: name,
    MktSelector: MktSelectors.builtDate,
    topContainerClassName: stateFieldClassNames,
    disabled: !isFieldEnabled || data.length === 0,
    renderFieldWrapper: renderFieldVerticalWrapper,
    renderFieldComponent: function fieldRenderer(_ref2) {
      let {
        input,
        meta
      } = _ref2;
      return selectFieldRenderer({
        input,
        meta,
        placeholder,
        className,
        options: data,
        disabled: !isFieldEnabled || data.length === 0,

        onChange(evt) {
          onChange && onChange(evt);
          sendUserSelect(evt.target.value);
        }

      });
    }
  }, props));
}